import './oiNewsPage.css';
import React, { Component } from 'react';

import axios from 'axios';
import History from '../../History';
import RenderHTML from 'react-render-html';
import DownAngleIcon from 'react-icons/lib/fa/angle-down';

import OiMenu from '../oiMenu/oiMenu';
import OiModal from '../oiModal/oiModal';
import OiLoading from '../oiLoading/oiLoading';
import OiHeaderLite from '../oiHeaderLite/oiHeaderLite';

class oiNewsPage extends Component {
    state = {
        title: '',
        image: null,
        preview: '',
        subtitle: '',
        content: null,
        isLoading: true,
        menuIsOpen: false,
        newsContent: null,
        modalIsOpen: false,
        newsId: this.props.location.search,
        msisdn: sessionStorage.getItem('msisdn'),
        phoneNumber: sessionStorage.getItem('phoneNumber'),
        modal: {
            title: null,
            text: null,
            btn1: null,
            btn2: null,
            event1: null,
            event2: null
        }
    };

    componentDidMount = () => {
        if (!sessionStorage.getItem("msisdn") || !sessionStorage.getItem("sessionToken") || !this.state.newsId) {
            History.push(`${process.env.PUBLIC_URL}/`);
        }
        else {
            document.getElementById('oi-header-lite').scrollIntoView({ block: "start" });

            this.getNewsContent();
            setTimeout(() => { this.refreshToken() }, (10 * 60 * 1000));
        }
    }

    manageModalWithCallback = (callback) => {
        this.setState({ modalIsOpen: !this.state.modalIsOpen });

        callback();
    }

    menuToogleHandler = () => {
        this.setState({ menuIsOpen: !this.state.menuIsOpen });
    }

    backToNewsHandler = () => {
        History.push(`${process.env.PUBLIC_URL}/noticias`);
    }

    scrollNewsHandle = () => {
        document.getElementById('oi-news-page-content-begin').scrollIntoView(
            {
                behavior: 'smooth',
                block: "start"
            }
        );
    }

    refreshToken = () => {
        //API REFRESH TOKEN
        let self = this;
        let url = 'https://api.oston.io/clicnoticia/v1/auth/token/refresh';
        const config = {
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('sessionToken')
            }
        };

        axios.post(url, {}, config)
            .then(refresh => {
                sessionStorage.setItem('sessionToken', refresh.data.token);
                setTimeout(() => { self.refreshToken() }, (10 * 60 * 1000));
            })
            .catch(error => {
                sessionStorage.removeItem('sessionToken');

                self.setState({
                    modalIsOpen: true,
                    isLoading: false,
                    modal: {
                        title: 'Atenção',
                        text: 'Sua sessão expirou. Por favor, faça login novamente.',
                        btn1: 'Ir para o login',
                        event1: () => {
                            self.manageModalWithCallback(() => {
                                History.push(`${process.env.PUBLIC_URL}/`);
                            })
                        }
                    }
                });
            });
    }

    getNewsContent = () => {
        //API GET NEWS BY ID
        let self = this;
        let aux = this.state.newsId;
        aux = aux.split('=');
        aux = aux[1];
        this.setState({ newsId: aux });

        let url = 'https://api.oston.io/clicnoticia/v2/news/' + aux;
        const config = {
            headers: {
                'Accept': 'application/json'
            }
        };

        axios.get(url, config)
            .then(response => {
                let title = '';
                let image = null;
                let preview = '';
                let subtitle = '';
                let content = [];
                let newsContent = response.data.data;

                title = RenderHTML(newsContent.title);

                if (newsContent.preview) {
                    preview = RenderHTML(newsContent.preview);
                }

                if (newsContent.subtitle) {
                    subtitle = RenderHTML(newsContent.subtitle);
                }

                content = RenderHTML(newsContent.text);

                if (newsContent.image) {
                    image = 'http://api.oston.io/images/publizee/' + newsContent.image;
                    content.splice((content.length / 2), 0,
                        <React.Fragment key="image-fragment">
                            <img src={image} alt="noticia-img" />
                            {newsContent.credit ? <span id="credit"> {newsContent.credit}</span> : ''}
                        </React.Fragment>
                    );
                }

                self.setState({ isLoading: false, title: title, preview: preview, subtitle: subtitle, content: content, image: image });
            })
            .catch(error => {
                self.setState({
                    modalIsOpen: true,
                    isLoading: false,
                    modal: {
                        title: 'Atenção',
                        text: 'Falha ao carregar a notícia. Por favor, recarregue a página.',
                        btn1: 'Recarregar',
                        event1: () => {
                            self.manageModalWithCallback(() => {
                                History.push(`${process.env.PUBLIC_URL}/noticia` + this.state.newsId);
                                window.location.reload();
                            })
                        }
                    }
                });
            });
    }

    render = () => {
        let Menu = '';

        if (sessionStorage.getItem('isBundle') === 'yes') {
            if (this.state.menuIsOpen) {
                Menu = (
                    <OiMenu
                        widthMenu={'75%'}
                        widthLayer={'100%'}
                        widthContainer={'100vw'}
                        phoneNumber={this.state.phoneNumber}
                        clickEvent={() => { this.menuToogleHandler() }}
                    />
                );
            }
            else {
                Menu = (
                    <OiMenu
                        widthMenu={'0'}
                        widthLayer={'0'}
                        widthContainer={'0'}
                        phoneNumber={this.state.phoneNumber}
                        clickEvent={() => { this.menuToogleHandler() }}
                    />
                );
            }
        }

        return (
            <div id="oi-news-page">
                {this.state.isLoading ? <OiLoading /> : ''}
                {this.state.modalIsOpen ? <OiModal modal={this.state.modal} /> : ''}
                {sessionStorage.getItem('isBundle') === 'yes' ? Menu : ''}

                {
                    sessionStorage.getItem('isBundle') === 'yes' ?
                        <OiHeaderLite
                            isBundle={true}
                            clickEvent={() => { this.menuToogleHandler() }}
                        />
                        :
                        <OiHeaderLite
                            isBundle={false}
                            clickEvent={() => { this.backToNewsHandler() }}
                        />
                }

                <div id="oi-news-page-box">

                    <div id="oi-news-page-cover">

                        <div id="oi-news-page-cover-shadow"></div>
                        {this.state.image ? <img id="oi-news-page-cover-img" src={this.state.image + '/BASEIMAGE'} alt="Cover" /> : ''}

                        <div id="oi-news-page-cover-text">
                            <h1>{this.state.title}</h1>
                            <p>{this.state.subtitle ? this.state.subtitle : this.state.preview}</p>
                        </div>

                        <div id="oi-news-page-cover-btn">
                            <p onClick={this.scrollNewsHandle}>Continue lendo</p>

                            <DownAngleIcon
                                id="oi-pin-down-angle-icon"
                                onClick={this.scrollNewsHandle}
                            />
                        </div>

                    </div>

                    <div id="oi-news-page-content">
                        <span id="oi-news-page-content-begin"></span>
                        <h1>{this.state.title}</h1>

                        <div id="oi-news-page-content-data">
                            {
                                this.state.subtitle !== '' ?
                                    <p id="subtitle">{this.state.subtitle}</p>
                                    : ''
                            }

                            {this.state.content}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default oiNewsPage;                                                         


// WEBPACK FOOTER //
// ./src/components/oiNewsPage/oiNewsPage.js